import { ONBOARDING_DONE } from '@/constants'
import { action, createRequestTypes } from '@/utils/actions.utils'
import { authService, localStorageService } from '@/services'
import { uiActions } from '@/redux/actions'

export const LOGGED = 'LOGGED'
const logged = () => {
	return action(LOGGED)
}

export const MODAL_AUTH_CLOSED = 'MODAL_AUTH_CLOSED'
const modalAuthClosed = () => {
	return action(MODAL_AUTH_CLOSED)
}

export const LOGIN_TIMEOUT = 'LOGIN_TIMEOUT'
const loginTimeout = (payload) => {
	return action(LOGIN_TIMEOUT, payload)
}

export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
const signUpSuccess = (payload) => {
	return action(SIGN_UP_SUCCESS, payload)
}

export const SIGN_UP_SOCIAL_ERROR = 'SIGN_UP_SOCIAL_ERROR'
const signUpSocialError = (payload) => {
	return action(SIGN_UP_SOCIAL_ERROR, payload)
}

export const SIGN_UP_SOCIAL_SUCCESS = 'SIGN_UP_SOCIAL_SUCCESS'
const signUpSocialSuccess = (payload) => {
	return action(SIGN_UP_SOCIAL_SUCCESS, payload)
}

export const QUALIFIED_SUCCESS = 'QUALIFIED_SUCCESS'
const qualifiedSuccess = () => {
	return action(QUALIFIED_SUCCESS)
}

export const QUALIFIED_ERROR = 'QUALIFIED_ERROR'
const qualifiedError = (payload) => {
	return action(QUALIFIED_ERROR, payload)
}

export const SUPPORT_CREDENTIALS_ERROR = 'SUPPORT_CREDENTIALS_ERROR'
const supportCredentialsError = (payload) => {
	return action(SUPPORT_CREDENTIALS_ERROR, payload)
}

export const GET_ACCOUNT_DETAILS = createRequestTypes('GET_ACCOUNT_DETAILS')
const getAccountDetails = (logErrors = true, silent = false) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ silent }))

			const res = await authService.getAccountDetails()
			return dispatch(success(res.data))
		} catch (error) {
			if (logErrors) {
				return dispatch(failure(error))
			}
			return dispatch(success(false))
		}
	}

	function request(payload) {
		return action(GET_ACCOUNT_DETAILS.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_ACCOUNT_DETAILS.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_ACCOUNT_DETAILS.FAILURE, null, err)
	}
}

export const LOGOUT = createRequestTypes('LOGOUT')
const logout = (isCurrentTokenValid = true, withNavigation = true) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			if (isCurrentTokenValid) {
				await authService.doLogout()
			}

			if (withNavigation) {
				dispatch(
					uiActions.setNavigation({
						preferredByUser: false,
						hasBeenActive: false
					})
				)
			}

			localStorageService.removeKey(ONBOARDING_DONE)

			return dispatch(success())
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(LOGOUT.REQUEST)
	}
	function success() {
		return action(LOGOUT.SUCCESS)
	}
	function failure(err) {
		return action(LOGOUT.FAILURE, null, err, false)
	}
}

export const SAVE_AUTH_TOKEN = 'SAVE_AUTH_TOKEN'
const saveAuthToken = (token) => {
	return {
		type: SAVE_AUTH_TOKEN,
		payload: token
	}
}

export const REFRESH_TOKEN = createRequestTypes('REFRESH_TOKEN')
const refreshToken = () => {
	return async (dispatch) => {
		await dispatch(request())
		try {
			const res = await authService.refreshToken()
			console.log('Token refreshed.')
			return dispatch(success(res.data))
		} catch(error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(REFRESH_TOKEN.REQUEST)
	}
	function success(payload) {
		return action(REFRESH_TOKEN.SUCCESS, payload)
	}
	function failure(err) {
		return action(REFRESH_TOKEN.FAILURE, null, err, false)
	}
}

export const SHOW_MODAL_AUTH = 'SHOW_MODAL_AUTH'
const showModalAuth = (value) => {
	return action(SHOW_MODAL_AUTH, value)
}

export default {
	logged,
	modalAuthClosed,
	loginTimeout,
	getAccountDetails,
	saveAuthToken,
	signUpSuccess,
	signUpSocialSuccess,
	signUpSocialError,
	qualifiedSuccess,
	qualifiedError,
	logout,
	refreshToken,
	supportCredentialsError,
	showModalAuth,
}
